import { STORAGE_KEYS } from "./constants";

export const isSuperAdmin = (value) => {
  return value === 1 || 
         value === true || 
         value === "true" || 
         value === "1";
};

export const extractDomainName = (input) => {
  if (!input) return '';
  
  let domain = input.trim().toLowerCase();
  domain = domain.replace(/^https?:\/\//, '');
  domain = domain.split('/')[0];
  domain = domain.split(':')[0];
  
  if (domain.startsWith('www.')) {
    domain = domain.substring(4);
  }
  
  return domain;
};

export const getInstallSource = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS.INSTALL_SOURCE);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    const THIRTY_MINUTES = 30 * 60 * 1000;

    if (Date.now() - parsed.timestamp > THIRTY_MINUTES) {
      localStorage.removeItem(STORAGE_KEYS.INSTALL_SOURCE);
      return null;
    }

    return parsed.value;
  } catch {
    localStorage.removeItem(STORAGE_KEYS.INSTALL_SOURCE);
    return null;
  }
};

export const clearAuthStorage = () => {
  console.log('Clearing authentication storage');
  localStorage.removeItem(STORAGE_KEYS.REFERRAL_CODE);
  localStorage.removeItem(STORAGE_KEYS.INSTALL_SOURCE);
  localStorage.removeItem(STORAGE_KEYS.ROLE);
  localStorage.removeItem(STORAGE_KEYS.REMEMBER_ME);
  localStorage.removeItem(STORAGE_KEYS.SESSION_CONFIG);
  localStorage.removeItem(STORAGE_KEYS.SHOW_STAY_LOGGED_IN_PROMPT);
  localStorage.removeItem('secret');
  localStorage.removeItem('domain_id');
  sessionStorage.removeItem(STORAGE_KEYS.SESSION_CONFIG);
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = (password) => {
  const rules = {
    minLength: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    specialChar: /[^A-Za-z0-9]/.test(password),
  };
  
  return {
    isValid: Object.values(rules).every(Boolean),
    rules
  };
};

export const getUserRole = (responseData) => {
  return responseData.role || 
         (responseData.domains && responseData.domains[0]?.role) || 
         "";
};

export const getDomainsFromResponse = (responseData) => {
  if (responseData.domains) {
    return responseData.domains;
  }
  if (responseData.domain_id) {
    return [{
      domain_id: responseData.domain_id,
      role: responseData.role || "",
    }];
  }
  return [];
};